import React from "react";
import { PurchasedList } from "../../components/PurchasedList";
import {
  BannerWrap,
  FlexList,
  ListItem,
  MainBanner,
  TopWrap,
  PointLabel,
  PointImg,
  PointTitle,
  PointDescription,
  PointAttention,
  LineBanner,
  LineBannerWrap,
} from "./elements";
import { PurchaseFlow } from "../../components/PurchaseFlow";
import Banner1 from "../../assets/images/banner1.jpg";
import Banner2 from "../../assets/images/banner2.jpg";
import LineBannerImg from "../../assets/images/line-banner.jpg";
import LowCost from "../../assets/images/low_cost.png";
import SmartphoneMan from "../../assets/images/smartphone_man.png";
import Track from "../../assets/images/track.png";
import { Section } from "../../components/Section";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper";

export const TopPage: React.FC = React.memo(() => {
  return (
    <TopWrap>
      <BannerWrap>
        <Swiper
          className="sample-slider"
          modules={[Autoplay]}
          loop={true}
          autoplay={{ delay: 2800 }}
        >
          <SwiperSlide>
            <MainBanner alt="banner1" src={Banner1} />
          </SwiperSlide>
          <SwiperSlide>
            <MainBanner alt="banner2" src={Banner2} />
          </SwiperSlide>
        </Swiper>
      </BannerWrap>
      <LineBannerWrap>
        <a href="https://lin.ee/qHqIHr6">
          <LineBanner alt="line-banner" src={LineBannerImg} />
        </a>
      </LineBannerWrap>
      <PurchasedList />
      <Section title="買取BestValueのここが凄い">
        <FlexList>
          <ListItem>
            <PointLabel>Point 1</PointLabel>
            <PointImg alt="lowCost" src={LowCost} />
            <PointTitle>無駄なコスト削減!!</PointTitle>
            <PointDescription>
              オンラインのみの為店舗経費なし、
              <br />
              人員最低限の為利益最小限で買取可能。
            </PointDescription>
          </ListItem>
          <ListItem>
            <PointLabel>Point 2</PointLabel>
            <PointImg alt="smartphoneMan" src={SmartphoneMan} />
            <PointTitle>スピード買取!!</PointTitle>
            <PointDescription>
              申し込みからお振り込みまで最短3日。（申し込み翌日集荷の場合）
            </PointDescription>
            <PointAttention>※他社の場合約2週間。</PointAttention>
          </ListItem>
          <ListItem>
            <PointLabel>Point 3</PointLabel>
            <PointImg alt="track" src={Track} />
            <PointTitle>配送費用全額負担!!</PointTitle>
            <PointDescription>
              郵送費用すべて弊社負担。
              <br />
              査定キャンセルの場合返送料も全額弊社負担。
            </PointDescription>
          </ListItem>
        </FlexList>
      </Section>
      <PurchaseFlow />
    </TopWrap>
  );
});

TopPage.displayName = "TopPage";
